import { ReadMore } from "../ReadMore";

import * as styles from "./TeamMembersAvatar.styles";

interface Props {
  avatar: string | null;
  name: string;
}

const TeamMembersAvatar = ({ avatar, name }: Props) => {
  const renderAvatar = () => {
    if (avatar) {
      return <img css={styles.avatarImage} src={avatar} alt={name} />;
    }

    return <i css={styles.icon} aria-hidden="true" className="fa fa-user" />;
  };

  return (
    <div css={styles.teamMembersAvatar}>
      {renderAvatar()}
      <ReadMore />
    </div>
  );
};

export { TeamMembersAvatar, type Props };
